export * from './response'
export * from './status';
export * from './dynamicData';
export * from './formly';
export * from './error';
export * from './toastr';
export * from './portalInfo';
export * from './error-response';
export * from './pageInfo';



// WEBPACK FOOTER //
// ./src/app/shared/types/index.ts